///////////////////////////////////////////////////////////////
// Basic JavaScript helpers

// Use this object via expando properties for globals within the shared components area.
var datSharedComponentGlobals = {};

datSharedComponentGlobals.eventNames = {
	GlobalUnhandledError: 'global.unhandled.error',
	Unauthorized401: 'unauthorized.401'
};



function detectIE() {
	'use strict';
	var browserInfo = getBrowserUseragentInfo();
	if (browserInfo && browserInfo.name === 'msie' || browserInfo.name === 'edge') {
		$('html').addClass('ie');
	}
}

$(document).ready(detectIE());

function getBrowserUseragentInfo() {
	var userBrowser = {};
	var uagent = navigator.userAgent.toLowerCase();
	var match = '';

	userBrowser.chrome = /webkit/.test(uagent) && /chrome/.test(uagent) && !/edge/.test(uagent);
	userBrowser.firefox = /mozilla/.test(uagent) && /firefox/.test(uagent);
	userBrowser.msie = /msie/.test(uagent) || /trident/.test(uagent);
	userBrowser.edge = /edge/.test(uagent);
	userBrowser.safari = /safari/.test(uagent) && /applewebkit/.test(uagent) && !/chrome/.test(uagent);
	userBrowser.opr = /mozilla/.test(uagent) && /applewebkit/.test(uagent) && /chrome/.test(uagent) && /safari/.test(uagent) && /opr/.test(uagent);

	userBrowser.version = '';
	userBrowser.name = '';

	for (var x in userBrowser) {
		if (userBrowser[x]) {
			userBrowser.name = x;
			// microsoft is "special"
			match = uagent.match(new RegExp('(' + (x === 'msie' ? 'msie|edge' : x) + ')( |\/)([0-9]+)'));
			if (match) {
				userBrowser.version = match[3];
			} else {
				match = uagent.match(new RegExp('rv:([0-9]+)'));
				userBrowser.version = match ? match[1] : '';
			}
			break;
		}
	}

	return {
		name: userBrowser.name,
		version: userBrowser.version
	};
}


if (typeof window.console === 'undefined') {
	// Create a fake console object if none exists. In IE9 window.console is only available when dev tools are open.
	// http://stackoverflow.com/questions/5472938/does-ie9-support-console-log-and-is-it-a-real-function#answer-5473193
	window.console = { log: function(str) {}, error: function(err) {} };
}

// TODO: review and refactor the way we open help and chat windows (make a directive?)
function openWindow(url, width, height) {
	var title = 'Help';
	var params = 'width=' + width + ', height=' + height + ', scrollbars=1';

	if (windowRef != null && !windowRef.closed) {
		if ($.browser.mozilla) {
			windowRef.close();
			windowRef = window.open(url, title, params);
		} else {
			windowRef.focus();
			windowRef.location = url;
		}
	} else {
		windowRef = window.open(url, title, params);
	}

	return windowRef;
}

function resolveUrl(url) {
	//return url.replace('~', window.tc.relativePath);
	return url.replace('~', '');
}

// expected format "yyyy-MM-ddTH:mm:ss-0:00"
function parseJsonDate(value) {

	if (!value) return null;
	if (_.isDate(value)) return value;

	var dateTime = value.split('T');
	var dateParts = dateTime[0].split('-');
	var year = parseInt(dateParts[0], 10);
	var month = parseInt(dateParts[1], 10) - 1;
	var day = parseInt(dateParts[2], 10);
	if (dateTime.length === 1) {
		return new Date(year, month, day);
	}

	var timeParts = dateTime[1].split('-')[0].split(':');
	var hour = parseInt(timeParts[0], 10);
	var minute = parseInt(timeParts[1], 10);
	var second = parseInt(timeParts[2], 10);

	return new Date(year, month, day, hour, minute, second);
}

Number.prototype.round = function(precision) {
	var factor = Math.pow(10, precision);

	return Math.round(this * factor) / factor;
};

Number.prototype.mod = function(n) {
	return this - (n * Math.floor(this / n));
};

Number.prototype.incrementalRound = function(roundIncrement, roundUp) {
	var tenthRemainder = this.mod(0.10);
	if (tenthRemainder > 0) {
		var base = (this - tenthRemainder).round(2);
		var roundedTenth = tenthRemainder > 0.05 ? 0.10 : 0;

		if (roundUp === false)
			return base - roundedTenth - roundIncrement;

		return base + roundedTenth + roundIncrement;
	}

	return this.round(2);
};
String.prototype.capitalize = function() {
	return this && this[0].toUpperCase() + this.slice(1);
};

String.prototype.toLowerCaseFirstChar = function() {
	return this && this[0].toLowerCase() + this.slice(1);
};

// formats to MM/dd/yyyy
Date.prototype.formatDate = function() {
	var s = '';
	var month = this.getMonth() + 1;
	var date = this.getDate();
	var year = this.getFullYear();
	if (month < 10)
		s += '0';
	s += month.toString() + '/';
	if (date < 10)
		s += '0';
	s += date.toString() + '/';
	s += year.toString();

	return s;
}; // sorts an array in place by one or more key functions and/or named properties
//
// example usage:
//      var list = [
//          { foo: 4, bar: 5, quux: 6 },
//          { foo: 4, bar: 5, quux: 7 },
//          { foo: 5, bar: 1, quux: 9 }
//      ];
//      list.sortBy(['foo', function(obj) { return obj.foo * obj.bar; }, 'quux'], true);
//
Array.prototype.sortBy = function(functionsOrPropertyNames, reverse) {
	if (!_.isArray(functionsOrPropertyNames)) return this.sortBy([functionsOrPropertyNames], reverse);
	var direction = 1;
	if (reverse) direction = -1;

	return this.sort(compare.bind(this, functionsOrPropertyNames));

	function compare(functionsOrPropertyNames, a, b) {
		var p = functionsOrPropertyNames[0];
		var aVal, bVal;
		if (_.isFunction(p)) {
			aVal = p(a);
			bVal = p(b);
		} else {
			aVal = a[p];
			bVal = b[p];
		}

		if (aVal === bVal) {
			if (functionsOrPropertyNames.length == 1) return 0;

			// otherwise recurse on the rest of the property names
			return compare(functionsOrPropertyNames.slice(1), a, b);
		}
		if (!aVal) return direction;
		if (!bVal) return -1 * direction;
		if (aVal < bVal) return -1 * direction;

		return -1;
	}
};

// remove item from the array, checking for reference identity
Array.prototype.removeItem = function(item) {
	for (var i = 0; i < this.length; i++) {
		if (this[i] === item) {
			this.splice(i, 1);

			return true;
		}
	}

	return false;
};

function objectToQueryString(obj) {
	var parts = [];
	for (var i in obj) {
		if (obj.hasOwnProperty(i)) {
			parts.push(encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]));
		}
	}

	return parts.join('&');
}

function parseQueryString(url) {
	var result = {};
	// Use the String::replace method to iterate over each
	// name-value pair in the query string. Location.search
	// gives us the query string (if it exists).
	url = url || window.location.search;
	//window.location.search.replace(new RegExp("([^?=&]+)(=([^&]*))?", "g"),
	url.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
		// For each matched query string pair, add that
		// pair to the URL struct using the pre-equals
		// value as the key.
		function($0, $1, $2, $3) {
			result[$1] = $3;
		}
	);

	return result;
}

// like _.extend, but will skip and not copy source properties that are arrays
function extendNonArrayProperties(dest, src) {
	for (var key in src) {
		if (src.hasOwnProperty(key) && !_.isArray(src[key]))
			dest[key] = src[key];
	}
}

function getDaysBackText(daysBack) {
	var lookBackDaysText = daysBack + ' days';
	if (daysBack === 1) {
		lookBackDaysText = 'day';
	}
	if (daysBack === 180) {
		lookBackDaysText = '6 months';
	}
	if (daysBack >= 365) {
		lookBackDaysText = 'year';
	}

	return lookBackDaysText;
}
